"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEmail = void 0;
function isEmail(value, options) {
    var isValid = true;
    var errors;
    var required = options && options.required !== undefined ? options.required : true;
    // RCC 5322 - source https://www.regular-expressions.info/email.html
    var emailRegex = /^(?=[a-zA-Z0-9@.!#$%&'*+/=?^_`{|}~-]{6,254}$)(?=[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]{1,254}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:(?=[a-zA-Z0-9-]{1,254}\.)[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+(?=[a-zA-Z0-9-]{1,254}$)[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;
    return (required && !value) || (value && !value.match(emailRegex))
        ? {
            isValid: false,
            errors: {
                value: value,
                constraints: {
                    isValidEmail: "false",
                },
            },
        }
        : {
            isValid: isValid,
            errors: errors,
        };
}
exports.isEmail = isEmail;
